<header
  class="navbar shadow"
  [tds-data-loader]="{ key: 'delete-user-activity', global: true, delay: 400 }"
>
  <div class="container-fluid">
    <div>
      <button
        class="navbar-brand p-0 focus-visible neutral-btn"
        [attr.title]="navigate_to_dashboard ? ('return_to_dashboard' | translate) : undefined"
        [attr.aria-label]="navigate_to_dashboard ? ('return_to_dashboard' | translate) : undefined"
        [attr.disabled]="!navigate_to_dashboard ? 'true' : undefined"
        (click)="returnToDashboard($event)"
      >
        <img class="business-logo" [attr.src]="logo_url" (error)="logoLoadError($event)" />
      </button>
    </div>

    @if (isUserLoggedIn()) {
      <div class="ms-auto flex-shrink-0 d-flex align-items-center justify-content-end">
        <!-- Cart Icon with cart items number -->
        <div class="pt-2 mt-1 me-2" [class.px-3]="!isPendoEnabled()">
          <div class="position-relative">
            <span class="material-icons material-symbols-outlined">shopping_cart</span>
            @if (getCartQuantity()) {
              <span
                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
              >
                {{ getCartQuantity() }}
              </span>
            }
          </div>
        </div>
        <!-- Pendo Help Icon -->
        @if (isPendoEnabled()) {
          <div class="px-3 mt-1 me-2">
            <button
              type="button"
              class="btn p-0 position-relative focus-visible neutral-btn"
              tabindex="0"
              [attr.aria-label]="'help_resource_center' | translate"
              [attr.title]="'help_resource_center' | translate"
            >
              <span class="material-icons material-symbols-outlined" aria-hidden="true">help</span>
            </button>
          </div>
        }
        <div
          ngbDropdown
          class="profile-icon"
          placement="bottom-right"
          #userProfileDropdown="ngbDropdown"
          (openChange)="dropDownOpenChange($event)"
        >
          <button
            ngbDropdownToggle
            id="Logout"
            class="text-white rounded-circle text-center display-6 mb-0 cursor-pointer d-inline-block menu-closed focus-visible focus-visible-rounded neutral-btn profile-icon__initials"
            [attr.style]="getBadgeStyleAttributes()"
          >
            {{ this.getUserInitials() | uppercase }}
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="Logout"
            class="dropdown-menu-end text-center pb-0 header-secondary"
          >
            <span
              class="text-white rounded-circle mt-2 display-6 mb-0 d-inline-block profile-icon__initials menu-open"
              [attr.style]="getBadgeStyleAttributes()"
            >
              {{ this.getUserInitials() | uppercase }}
            </span>
            <div class="row d-flex flex-column align-items-center px-4 py-3">
              <div class="col text-center">
                <h6 class="mb-0 display-6 header-primary">{{ getProfileUserName() }}</h6>
              </div>
              <div class="col text-center">
                <small class="text-secondary">{{ getEmail() }}</small>
              </div>
              @if (getIsMasquerading()) {
                <div class="col text-center mt-1">
                  <ts-badge text="{{ 'masquerading' | translate }}" />
                </div>
              }
            </div>
            @if (getUserApplicationName()) {
              <div class="dropdown-divider m-0"></div>
            }
            @if (getUserApplicationName()) {
              <div class="row py-3">
                <div class="col d-flex">
                  <button
                    stop-click-propagation
                    class="align-items-center mx-2 flex-grow-1 focus-visible neutral-btn header-secondary"
                    (click)="navigateToUserApplication()"
                  >
                    <span class="material-icons-outlined ms-2 pe-1 fs-6">open_in_new</span>
                    <span class="fw-light">{{ getUserApplicationName() }}</span>
                  </button>
                </div>
              </div>
            }
            <div class="dropdown-divider m-0"></div>
            <div ngbAccordion #themeSwitcher="ngbAccordion">
              <div ngbAccordionItem [collapsed]="true">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="px-2 focus-visible focus-visible-inset">
                    <span class="ms-2 me-1 fs-6 material-icons">
                      {{ theme_svc.currentTheme() }}_mode
                    </span>
                    <span class="fw-light">{{ 'theme' | translate }}</span>
                  </button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody class="row">
                    <ng-template>
                      <div class="col col-12 d-flex flex-column align-items-stretch p-0">
                        <button
                          class="align-items-center ms-1 px-2 header-primary focus-visible neutral-btn"
                          (click)="theme_svc.toggleLightTheme()"
                          stop-click-propagation
                        >
                          <span class="me-1 fs-6 material-icons">light_mode</span>
                          <span
                            [ngClass]="[
                              !theme_svc.isDarkTheme() ? 'fw-normal' : 'fw-light header-secondary'
                            ]"
                          >
                            {{ 'theme_light' | translate }}
                          </span>
                          @if (!theme_svc.isDarkTheme()) {
                            <span class="ms-auto fs-6 material-icons"> check </span>
                          }
                        </button>
                        <button
                          class="align-items-center mt-3 ms-1 px-2 focus-visible neutral-btn header-primary"
                          (click)="theme_svc.toggleDarkTheme()"
                          stop-click-propagation
                        >
                          <span class="me-1 fs-6 material-icons">dark_mode</span>
                          <span
                            [ngClass]="[
                              theme_svc.isDarkTheme() ? 'fw-normal' : 'fw-light header-secondary'
                            ]"
                          >
                            {{ 'theme_dark' | translate }}
                          </span>
                          @if (theme_svc.isDarkTheme()) {
                            <span class="ms-auto fs-6 material-icons"> check </span>
                          }
                        </button>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="dropdown-divider m-0"></div>
            <div class="row py-3">
              <div class="col d-flex">
                <button
                  stop-click-propagation
                  class="align-items-center mx-2 flex-grow-1 focus-visible neutral-btn header-secondary"
                  (click)="logout()"
                >
                  <span class="material-icons-outlined ms-2 pe-1 fs-6">logout</span>
                  <span class="fw-light">{{ 'logout' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</header>
